import { Box, Typography, Chip, Tooltip, TextField, ListItemIcon, MenuItem, MenuList, Popover, withStyles } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation,
  useServices
} from 'cng-web-lib'
import ISF10ApiUrls from 'src/apiUrls/ISF10ApiUrls'
import React, { useEffect, useRef, useState, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Namespace from 'src/constants/locale/Namespace'
import Table from '../../../components/aciacehighway/Table'
import { FileForUserGetPartyId, FileForUserGetUserDetails, GetFilterByUserIdCriteria } from 'src/common/FileForUserCommon'
import pathMap from 'src/paths/pathMap'
import { getStatusMetadata } from '../../../common/NACommon'
import moment from 'moment-timezone'
import { AceIsfTranslationContext } from '../contexts/ACEISFTranslationContext'
import Paper from '@material-ui/core/Paper'
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import TemplateSelectDialogWithOption from '../isf10/TemplateSelectDialogWithOption'
import UserProfileApiUrls from "src/apiUrls/UserProfileApiUrls";
import FileForUserContext from 'src/contexts/FileForUserContext'
import { format } from 'date-fns'

const {
  table: { useDefaultNotification, useFetchCodeMaintenanceLookup },
  CngDialog,
  button: { CngPrimaryButton, CngSecondaryButton }
} = components

const {
  filter: { BETWEEN, EQUAL, IN, LIKE }
} = constants

function TablePage(props) {
  const { history, location, manifestId, showNotification } = props
  const [isf10TemplateDialog, setIsf10TemplateDialog] = useState(false)
  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.ISF10
  ])
  const tableRef = useRef(null)
  const { createRecord, deleteRecord, fetchRecords, securedSendRequest } = useServices()
    const [confirmDialog, setConfirmDialog] = useState({ open: false, isf10: null })
    const [exportDialog, setExportDialog] = useState(false)
    const [exportDateFrom, setExportDateFrom] = useState('')
    const [exportDateTo, setExportDateTo] = useState('')
    const [dateFromError, setDateFromError] = useState('')
    const [dateToError, setDateToError] = useState('')
    const [exportDateError, setExportDateError] = useState('')
    const DEFAULT_MAX_EXPORT_MONTHS = 6
    const [maxExportMonths, setMaxExportMonths] = useState(DEFAULT_MAX_EXPORT_MONTHS)
    const [sbPartyIdList, setSBPartyIdList] = useState([])
    const [sbPartyIdFetched, setSBPartyIdFetched] = useState(false)
    const { getTranslatedText } = useContext(AceIsfTranslationContext)
    const { partyConfigFetched } = useContext(FileForUserContext)
    const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()

    useEffect(() => {
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [
          { field: 'codeType', operator: EQUAL, value: 'ISF_EXPORT_CONF' },
          { field: 'code',     operator: EQUAL, value: 'MONTH_INTERVAL' }
        ],
        undefined,
        'code'
      ).then((result) => {
        const months = result && result['MONTH_INTERVAL']
          ? parseInt(result['MONTH_INTERVAL'], 10)
          : NaN
        setMaxExportMonths(!isNaN(months) ? months : DEFAULT_MAX_EXPORT_MONTHS)
      }).catch((error) => {
        console.error('Failed to fetch ISF export config, using default:', error)
      })
    }, [])

  let columns = [
    {
      field: 'cbpTransactionNo',
      sortKey: 'cbpTransactionNo',
      title: getTranslatedText('ACE_ISF', 'cbpTransactionNo'),
    },
    {
      field: 'importerRefNo',
      sortKey: 'importerRefNo',
      title: getTranslatedText('ACE_ISF', 'importerRefNo'),
    },
    {
      field: 'blNo',
      sortKey: 'blNo',
      title: getTranslatedText('ACE_ISF', 'shipmentReference'),
      render: (data) => {
        let content = []
        data.shipments.map(function (object, i) {
          content.push(
            <Chip key='first' label={object.blType + " | " + object.blNo + (object.blMatched ? " | " + object.blMatched : "")} />
          )
        })

        return (
          <>
            <Box display='flex' flexDirection='row' flexWrap='wrap' style={{ gap: 4 }}>
              {content}
            </Box>
          </>
        )
      }
    },
    {
      field: 'refBookingNo',
      sortKey: 'refBookingNo',
      title: getTranslatedText('ACE_ISF', 'refBookingNo'),
    },
    {
      field: 'status',
      sortKey: 'status',
      title: getTranslatedText('ACE_ISF', 'status'),
      render: (data) => {
        const status = getStatusMetadata(data.status)

        return (
          <>
            <Tooltip key='more' title='View response(s)' placement='top'>
              <Chip
                label={status.label}
                size='small'
                style={{
                  backgroundColor: status.color,
                  color: status.contrastColor
                }}
                clickable
              // onClick={(event) => {
              //   event.stopPropagation()
              //   setQuickGlanceResponseLogDialog({ open: true, manifest: data })                
              // }}
              />
            </Tooltip>
            <Typography color='textSecondary' style={{ fontSize: 12, lineHeight: 1.2 }}>
              {data.responseDateTime && moment(data.responseDateTime).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')}
            </Typography>
          </>
        )
      }
    },
    {
      field: 'createdDate',
      sortKey: 'createdDate',
      title: getTranslatedText('ACE_ISF', 'createdDateTime'),
      render: (data) =>
        data.createdDate && moment(data.createdDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'submittedDateTime',
      sortKey: 'submittedDateTime',
      title: getTranslatedText('ACE_ISF', 'submittedDateTime'),
      render: (data) => data.submittedDateTime && moment(data.submittedDateTime).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    }
    //responseDateTime
  ]

  const filters = [
    {
      label: getTranslatedText('ACE_ISF', 'cbpTransactionNo'),
      type: 'textfield',
      name: 'cbpTransactionNo',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACE_ISF', 'importerRefNo'),
      type: 'textfield',
      name: 'importerRefNo',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACE_ISF', 'shipmentReference'),
      type: 'textfield',
      name: 'blNo',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACE_ISF', 'refBookingNo'),
      type: 'textfield',
      name: 'refBookingNo',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACE_ISF', 'status'),
      type: 'checkbox',
      name: 'status',
      operatorType: IN,
      options: [
        {
          label: 'Draft',
          value: 'draft',
          filterValue: {
            value: '1005'
          }
        },
        {
          label: 'Accepted',
          value: 'accepted',
          filterValue: {
            value: '1000'
          }
        },
        {
          label: 'Sent',
          value: 'sent',
          filterValue: {
            value: '1008'
          }
        },
        {
          label: 'Rejected',
          value: 'rejected',
          filterValue: {
            value: '1001'
          }
        },
        /*{
          label: 'Template',
          value: 'Template',
          filterValue: {
            value: '1002'
          }
        },*/
        {
          label: 'Status Notification',
          value: 'status_notification',
          filterValue: {
            value: '1006'
          }
        },
        {
          label: 'Cancellation Accepted',
          value: 'cancellation_accepted',
          filterValue: {
            value: '1003'
          }
        },
        {
          label: 'Cancellation Rejected',
          value: 'cancellation_rejected',
          filterValue: {
            value: '1004'
          }
        },
        {
          label: 'Modification Rejected',
          value: 'modification_rejected',
          filterValue: {
            value: '1007'
          }
        }
      ]
    },
    {
      label: getTranslatedText('ACE_ISF', 'createdDateTime'),
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    },
    {
      label: getTranslatedText('ACE_ISF', 'submittedDateTime'),
      type: 'daterange',
      name: 'submittedDateTime',
      operatorType: BETWEEN
    },
  ]

  function checkDateRangeError(from, to) {
    if (!from || !to) return ''
    const fromMoment = moment(from, 'YYYY-MM-DD', true)
    const toMoment   = moment(to,   'YYYY-MM-DD', true)
    if (!fromMoment.isValid() || !toMoment.isValid()) return ''
    if (fromMoment.isAfter(toMoment)) return 'Start date cannot be after end date.'
    const limitMoment = fromMoment.clone().add(maxExportMonths, 'months')
    if (toMoment.isAfter(limitMoment)) {
      return `Date range cannot exceed ${maxExportMonths} months.`
    }
    return ''
  }

  function validateDates() {
    let isValid = true
    if (!exportDateFrom) {
      setDateFromError('Date From is required')
      isValid = false
    } else {
      setDateFromError('')
    }
    if (!exportDateTo) {
      setDateToError('Date To is required')
      isValid = false
    } else {
      setDateToError('')
    }
    if (exportDateFrom && exportDateTo) {
      const rangeError = checkDateRangeError(exportDateFrom, exportDateTo)
      setExportDateError(rangeError)
      if (rangeError) isValid = false
    }
    return isValid
  }

  function handleExport(fileType) {
    if (validateDates()) {
      exportTransaction(exportDateFrom, exportDateTo, fileType)
      setExportDialog(false)
    }
  }

  function exportTransaction(dateFrom, dateTo, fileType) {
    const config = { responseType: 'blob' }
    const isPdf = fileType === 'PDF'

    const partyIdRaw = sbPartyIdList.length > 0 ? sbPartyIdList : FileForUserGetPartyId()
    const partyId = Array.isArray(partyIdRaw) ? partyIdRaw[0] : partyIdRaw

    // Convert Table's internal tableFilters format  { field, operator, value, type }
    // → backend filterProperties format             { fieldName, operatorType, value1, value2 }
    const activeTableFilters = (tableRef.current?.tableFilters || []).map((f) => {
      if (f.type === 'date' && f.value && f.value.startDate && f.value.endDate) {
        // daterange filter — split into value1 / value2
        return {
          fieldName:    f.field,
          operatorType: f.operator.toUpperCase(),
          value1:       f.value.startDate,
          value2:       f.value.endDate
        }
      }
      // textfield / checkbox(IN) / radio filters — single value
      return {
        fieldName:    f.field,
        operatorType: f.operator.toUpperCase(),
        value1:       f.value
      }
    })

    // filterProperties = fixed fetchFilters  +  active column search filters
    // .toUpperCase() is required because cng-web-lib filter constants are lowercase (e.g. "like", "equal")
    const filterProperties = [
      { fieldName: 'templateFlag', operatorType: 'EQUAL', value1: '0' },
      { fieldName: 'partyId',      operatorType: 'EQUAL', value1: partyId },
      ...filter.map((f) => ({ fieldName: f.field, operatorType: f.operator.toUpperCase(), value1: f.value })),
      ...activeTableFilters
    ]

    // sortProperties — use live table sort, falling back to default
    const liveSorts = tableRef.current?.tableSorts || []
    const sortProperties = liveSorts.length > 0
      ? liveSorts.map((s) => ({ sortField: s.field, sortType: s.direction }))
      : [{ sortField: 'createdDate', sortType: 'DESC' }]

    // mapProp — columns as a numeric-string-keyed object (matches cng-web-lib exportRecords)
    const mapProp = {}
    columns.forEach((col, idx) => {
      mapProp[String(idx)] = { field: col.field, title: col.title }
    })

    const requestBody = {
      baseFilterDTO: {
        filterType: 'AND',
        filterProperties,
        sortProperties
      },
      customData: {
        mapProp,
        searchDateFrom: dateFrom,
        searchDateTo:   dateTo
      }
    }

    let fileForUserDetails = FileForUserGetUserDetails()
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      requestBody.customData.fileForUserId      = fileForUserDetails.fileForUserId
      requestBody.customData.fileForUserLoginId = fileForUserDetails.fileForUserLoginId
      requestBody.customData.fileForUserPartyId = fileForUserDetails.fileForUserPartyId
    }

    securedSendRequest.execute(
      'POST',
      ISF10ApiUrls.EXPORTISF10 + '?fileType=' + fileType,
      requestBody,
      async (response) => {
        if (response?.data !== '' && response?.data !== null && response?.data !== undefined) {
          const responseData = response.data
          const isJsonBlob = responseData instanceof Blob && responseData.type === 'application/json'
          if (isJsonBlob) {
            const text = await responseData.text()
            const parsed = JSON.parse(text)
            if (parsed?.errorMessages && parsed.errorMessages.length > 0) {
              parsed.errorMessages.forEach((msg) => showNotification('error', msg))
            } else {
              showNotification('success', parsed?.message || 'Export completed successfully')
            }
          } else {
            const ext = isPdf ? '.pdf' : '.csv'
            const filename = 'ISF10_EXPORT_' + format(new Date(), 'yyyyMMddHHmmss') + ext
            const url = window.URL.createObjectURL(new Blob([responseData]))
            const a = document.createElement('a')
            a.href = url
            a.download = filename
            a.click()
            showNotification('success', 'Export completed successfully')
          }
        }
      },
      (error) => {
        showNotification('error', 'Something went wrong during export transaction')
      },
      undefined,
      config,
      null
    )
  }

  function handleCloneISF10(data) {
    createRecord.execute(
      ISF10ApiUrls.CLONE,
      data,
      (data) => {
        data.cloneFrom = data.importerRefNo;
        // const shipmentDataList = data.shipments.map(
        //   (shipment, index) => ({ ...shipment, _id: index + 1 })
        // )
        // data.shipments = shipmentDataList

        // const partyDataList = data.parties.map(
        //   (party, index) => ({ ...party, _id: index + 1 })
        // )
        // data.parties = partyDataList

        // const containerDataList = data.containers.map(
        //   (container, index) => ({ ...container, _id: index + 1 })
        // )
        // data.containers = containerDataList
        // data.expArrivalTime = moment(data.expArrivalDate).format('HH:mm');
        // data.expArrivalDate = moment(data.expArrivalDate).format('YYYY-MM-DD');
        history.push(pathMap.ACEISF10_ADD_VIEW, data)
      },
      (error) => {
        console.log(error)
      }
    )
  }
  function handlePrintIsf10(data) {
    const config = { responseType: 'blob' }

    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      data.fileForUserId = fileForUserDetails.fileForUserId;
      data.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      data.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }

    securedSendRequest.execute(
      'POST',
      ISF10ApiUrls.PRINTISF10,
      data,
      (response) => {
        let blob = new Blob([response.data])

        let first = 'ISF_10_'
        let curDate = format(new Date(), 'yyyyMMddHHmmss')
        let filename = first + curDate + '.pdf'
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
      },
      (error) => console.error(error),
      undefined,
      config,
      null
    )
  }

  function handleDeleteISF10() {
    if (confirmDialog.isf10) {
      deleteRecord.execute(
        ISF10ApiUrls.DELETE,
        confirmDialog.isf10,
        () => {
          showNotification('success', 'Delete succeeded')
          setConfirmDialog({ open: false, isf10: null })
          setIsf10TemplateDialog(false)
          tableRef.current.performRefresh()
        },
        (error) => {
          console.log(error)
        }
      )
    }
  }

  useEffect(() => {
    let loginId = "";
    let userPreference = localStorage.getItem("userPreference");
    let fileForUserDetails = sessionStorage.getItem("fileForUserDetails");
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      setSBPartyIdList([])
      setSBPartyIdFetched(true);
    } else {
      let userPreferenceJSON = JSON.parse(userPreference);
      loginId = userPreferenceJSON.tprUserDetail.userProfile.loginId;
    }
    console.log("loginId: " + JSON.stringify(loginId));

    if (loginId !== "") {
      function onSuccess(response) {
        setSBPartyIdList(response.data)
        setSBPartyIdFetched(true);
        console.log("sbPartyIdList: " + JSON.stringify(sbPartyIdList));
      }

      function onError(error) {
        console.log("sbPartyIdList Error: " + JSON.stringify(error));
      }

      function onComplete() { }
      const config = {}

      securedSendRequest.execute('POST', UserProfileApiUrls.SB_PARTYID_LIST, { loginId }, onSuccess, onError, onComplete, config, null);

    }
  }, [])

  let filter = GetFilterByUserIdCriteria("ACEISF")

  return (
    <>
      {sbPartyIdFetched && partyConfigFetched && (<Table
        actions={[
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'file-export']} />,
              onClick: () => setExportDialog(true)
            },
            label: 'Export'
          },
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.ACEISF10_ADD_VIEW)
            },
            label: 'Create ISF'
          },
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => setIsf10TemplateDialog(true)
            },
            label: 'ISF Template'
          }
        ]}
        columns={columns}
        compact
        fetch={{ url: ISF10ApiUrls.GET }}
        fetchFilters={[
          { field: 'templateFlag', operator: EQUAL, value: '0' },
          { field: 'partyId', operator: IN, value: sbPartyIdList.length > 0 ? sbPartyIdList : FileForUserGetPartyId() },
          ...filter
        ]}
        filters={filters}
        onRowClick={(rowData) => {
          if (rowData.status === '1008') {
            history.push(`${location.pathname}/view/${rowData.id}`)
          }
          else {
            history.push(`${location.pathname}/edit/${rowData.id}`)
          }
        }
        }
        rowActions={[
          {
            disabled: (rowData) => rowData.status === '1008',
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: getTranslatedText('ACE_ISF', 'editButton'),
            onClick: (rowData) =>
              history.push(`${location.pathname}/edit/${rowData.id}`),
            tooltip: (rowData) =>
              rowData.status === '1008'
                ? getTranslatedText('ACE_ISF', 'editSentRecords')
                : null
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
            label: getTranslatedText('ACE_ISF', 'cloneButton'),
            onClick: handleCloneISF10
          },
          {
            label: getTranslatedText('ACE_ISF', 'printISF10'),
            icon: <FontAwesomeIcon icon={['fal', 'print']} />,
            onClick: handlePrintIsf10
          },
          {
            disabled: (data) => data.status !== '1005' || data.submittedDateTime != null,
            label: getTranslatedText('ACE_ISF', 'deleteButton'),
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            onClick: (data) => setConfirmDialog({ open: true, isf10: data }),
            tooltip: (rowData) =>
              rowData.status !== '1005' || rowData.submittedDateTime != null
                ? getTranslatedText('ACE_ISF', 'deleteRecordErrorMessage')
                : null
          },
        ]}
        showNotification={showNotification}
        sortConfig={{
          type: 'column',
          defaultField: 'createdDate',
          defaultDirection: 'DESC'
        }}
        tableRef={tableRef}
        checkboxSelection
        tablePreference={{ module: 'ISF10', key: 'isf10_table_visible_column' }}
      />)}

     <CngDialog
        customDialogContent={
          <Paper>
            <Box m={2} mt={1}>
              <Box mt={1}>
                <TextField
                  label='Date From'
                  type='date'
                  value={exportDateFrom}
                  onChange={(e) => {
                    setExportDateFrom(e.target.value)
                    if (dateFromError) setDateFromError('')
                    if (exportDateError) setExportDateError('')
                  }}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required
                  error={!!dateFromError}
                  helperText={dateFromError}
                />
              </Box>
              <Box mt={2}>
                <TextField
                  label='Date To'
                  type='date'
                  value={exportDateTo}
                  onChange={(e) => {
                    setExportDateTo(e.target.value)
                    if (dateToError) setDateToError('')
                    if (exportDateError) setExportDateError('')
                  }}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required
                  error={!!dateToError}
                  helperText={dateToError}
                />
              </Box>
              {exportDateError && (
                <Box mt={1}>
                  <Typography color='error' variant='caption'>
                    {exportDateError}
                  </Typography>
                </Box>
              )}
              <Box display='flex' flexDirection='row-reverse' mt={2} style={{ gap: 8 }}>
                <ExportFormatPopover onExport={(fileType) => handleExport(fileType)} />
                <Box mr={1}>
                  <CngSecondaryButton
                    onClick={() => {
                      setExportDialog(false)
                      setExportDateFrom('')
                      setExportDateTo('')
                      setDateFromError('')
                      setDateToError('')
                      setExportDateError('')
                    }}
                  >
                    Cancel
                  </CngSecondaryButton>
                </Box>
                <Box flexGrow={1} />
              </Box>
            </Box>
          </Paper>
        }
        dialogTitle={<><b>Export</b></>}
        onClose={() => {
          setExportDialog(false)
          setExportDateFrom('')
          setExportDateTo('')
          setDateFromError('')
          setDateToError('')
          setExportDateError('')
        }}
        open={exportDialog}
        fullWidth
        maxWidth='sm'
      />

      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog.open}
        closeDialog={() => setConfirmDialog({ open: false, isf10: null })}
        confirmDialog={handleDeleteISF10}
        content="Items that you delete can't be restored. Are you sure about this?"
        okMsg='Yes, delete'
        cancelMsg='No, take me back'
        title={getTranslatedText('ACE_ISF', 'deleteButton')}
      />
      <TemplateSelectDialogWithOption
        isfTemplateDialog={isf10TemplateDialog}
        setIsfTemplateDialog={setIsf10TemplateDialog}
        setConfirmDialog={setConfirmDialog}
        showNotification={showNotification}
        isTable={true}
        location={location}
        rowActions={[
          {
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: 'Edit',
            onClick: (rowData) =>
              history.push(pathMap.ACEISF10 + `/edit/${rowData.id}`),
            tooltip: () => 'edit'
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: 'Delete',
            onClick: (rowData) =>
              setConfirmDialog({ open: true, isf10: rowData }),
            tooltip: () => 'delete'
          }
        ]}
      />
    </>
  )
}

export default TablePage

// ---------------------------------------------------------------------------
// ExportFormatPopover – CSV / PDF chooser button
// ---------------------------------------------------------------------------
const StyledPopoverWrapper = withStyles(() => ({
  root: { maxWidth: '100%', padding: 4, width: 200 }
}))(Paper)

const StyledPopoverHeader = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.sectionOddBg,
    padding: '8px 16px',
    '& .MuiTypography-root': { fontSize: 14, fontWeight: 700 }
  }
}))(Box)

function ExportFormatPopover({ onExport }) {
  const [anchorEl, setAnchorEl] = useState(null)

  function handleClose() { setAnchorEl(null) }

  return (
    <>
      <CngPrimaryButton
        startIcon={<FontAwesomeIcon icon={['fal', 'file-export']} />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        Export
      </CngPrimaryButton>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <StyledPopoverWrapper>
          <StyledPopoverHeader>
            <Typography variant='body2'>Export as</Typography>
          </StyledPopoverHeader>
          <MenuList>
            <MenuItem onClick={() => { onExport('CSV'); handleClose() }}>
              <ListItemIcon>
                <FontAwesomeIcon icon={['fal', 'file-csv']} size='lg' />
              </ListItemIcon>
              <Typography variant='body2' style={{ fontWeight: 700 }}>CSV</Typography>
            </MenuItem>
            <MenuItem onClick={() => { onExport('PDF'); handleClose() }}>
              <ListItemIcon>
                <FontAwesomeIcon icon={['fal', 'file-pdf']} size='lg' />
              </ListItemIcon>
              <Typography variant='body2' style={{ fontWeight: 700 }}>PDF</Typography>
            </MenuItem>
          </MenuList>
        </StyledPopoverWrapper>
      </Popover>
    </>
  )
}
